import confetti, { CreateTypes, Options } from 'canvas-confetti';

export function fireConfetti(canvas: HTMLCanvasElement): void {
	const customConfetti = confetti.create(canvas, { useWorker: true, resize: true });

	fireConfettiCloud(customConfetti, 0.25, {
		spread: 26,
		startVelocity: 35,
	});

	fireConfettiCloud(customConfetti, 0.2, {
		spread: 60,
		startVelocity: 25,
	});

	fireConfettiCloud(customConfetti, 0.35, {
		spread: 100,
		decay: 0.91,
		startVelocity: 35,
	});

	fireConfettiCloud(customConfetti, 0.1, {
		spread: 120,
		startVelocity: 15,
		decay: 0.92,
	});

	fireConfettiCloud(customConfetti, 0.1, {
		spread: 120,
		startVelocity: 25,
	});
}

function fireConfettiCloud(customConfetti: CreateTypes, particleRatio: number, options: Options): void {
	void customConfetti({
		origin: { x: 0.5, y: 1 },
		colors: [ '#2578ea', '#33ff99', '#9999ff', '#ff6666' ],
		zIndex: 99_999,
		...options,
		particleCount: Math.floor(400 * particleRatio),
		ticks: 130,
		scalar: 0.5,
	});
}
